import { Checkbox, Collapse, Fade } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { map, noop } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Alert, Database, ModalController, UserManager } from '../../Managers/exports';
import { formatPhone } from '../../Utilities';
import { Input } from '../Input/Input';
import "./Modal.css";
import "../Input/Input.css"
import {COUNTRIES} from '../../Constants';
import { reduce } from 'lodash'
import { BlackBod } from '../BlackBod/BlackBod';

import styled from 'styled-components';

const A = styled.a`
    text-decoration: underline;
    font-size: 1em;
    font-weight: normal;
    color: blue !important;
    margin: 0;
`
export const Modal = props => {


    const [isActive, setIsActive] = useState(0)
    const [type, setModalType] = useState("")
    const leaving = new Subject()
    useEffect(() => {
        ModalController.get()
        .pipe(takeUntil(leaving))
        .subscribe(setIsActive)

        ModalController.getModalType()
        .pipe(takeUntil(leaving))
        .subscribe(setModalType)
        return () => leaving.next()
    })


    return(
        <Fade in={!!isActive} timeout={500}>
            <div className="container">
                <InnerModal  blackBaud={type === "donate"}/>
            </div>
        </Fade>
    )
}


const InnerModal = props => {

    const [full, setFull] = useState(false)
    const [email, setEmail] = useState("")
    const [first, setFirst] = useState("")
    const [last, setLast] = useState("")
    const [phone, setPhone] = useState("")
    const [zip, setZip] = useState("")
    const [drawing, setDrawing] = useState(false)
    const [consent, setConsent] = useState(false)
    const [country, setCountry] = useState("US")


    const {blackBaud} = props
    const [errors, setErrors] = useState({
        email: false,
        first: false,
        last: false,
        phone: false,
        zip: false,
        country: false,
        consent: false
    })
    
    const [state, setState] = useState(0)
    const leaving = new Subject()
    useEffect(() => {
        ModalController.get()
        .pipe(takeUntil(leaving))
        .subscribe(setState)
        return () => leaving.next()
    })

    const onConsentChange = () => {
        setConsent(!consent)
    }

    const onDrawingChange = () => {
        setDrawing(!drawing)
    }

    const formatPhoneNumber = (value)=> {
        const formatted = formatPhone(value)
        setPhone(formatted)
    }
    const onCheck = async () => {
        try{
            if(email == ""){
                Alert.default("Email Required")
                return
            }
           let registered =  await UserManager.checkValidProfile(email)

           if(registered){
               Alert.success("You're all set!")
               ModalController.close()
           } else {
            ModalController.expand()
           }

        } catch(e) {
            Alert.warning(e)
        }
    }
    const hasFormError = () => {
        let _errors = {...errors}
        const emailreg = RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i)
        _errors.email   = !email || !!email && email.trim() === "" || !emailreg.test(email)
        _errors.first   = !first || !!first && first.trim() === ""
        _errors.last    = !last || !!last && last.trim() === ""
        if(drawing){
            // const phonereg = RegExp(/^[0-9()-]+$/)
            _errors.phone    = !phone || !!phone && phone.trim() === "" 
        } else {
            _errors.phone = false
        }
        if(country == "US"){
            const zipreg = new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/i)
            _errors.zip     = !zip || !zipreg.test(zip)
        } else {
            _errors.zip     = !zip 
        }
        
        _errors.country = !country || !!country && country.trim() === ""
        _errors.consent = !consent

        let hasError = reduce(_errors, (result, value, key) => {
            return result || value
        })
        setErrors({..._errors})
        return hasError
    }


    const onSubmit = async () => {
        if(hasFormError()){
            return
        }
        // let type;
        // if(drawing){
        //     // confirm if the number is valid
        //     try{
        //         let response = await Database._getRaw(`https://us-central1-iiwtv-139f6.cloudfunctions.net/v1/valid-phone/${phone}`)
        //         if(!response?.carrier?.type){
        //              Alert.error(`${phone} doesn't seem to be a valid phone number.  Please enter a valid number.`)
        //              setErrors({...errors, phone: true})
        //              return
        //         }

        //         type = response?.carrier?.type
        //     } catch(e) {
        //         if(e.status > 399){
        //             Alert.error(`${phone} doesn't seem to be a valid phone number.  Please enter a valid number.`)
        //             setErrors({...errors, phone: true})
        //             return
        //         } else {
        //             Alert.error("An unknown error occured")
        //         }
        //     }
            
        // }

        try{
            await UserManager.register(
                email,
                first,
                last,
                phone,
                zip,
                country,
                consent,
                drawing
            )

            Alert.success("You're Registered")
            ModalController.close()
        }catch(e) {
            Alert.warning(e)
        }
    }

    const _onSubmit = () => {
        if(!!onSubmit){
            onSubmit()
        }
    }

    const _onCheck = () => {
        if(!!onCheck){
            onCheck()
        }
    }
    const onNext = () => {
        switch(state){
            case 1: _onCheck(); break;
            case 2: _onSubmit(); break;
            default: noop();
        }
    }

    return (
        <Fade in={true}>
            <>
            {!!blackBaud && <BlackBod />}
            {!blackBaud && <div className="modal-container">
                <div className="modal-header">
                    <h5 className="input-header-title">Register / Login for Connect</h5>
                    <button type="button" className="close" onClick={ModalController.close} aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-content" >
                    <Form 
                        full={full}
                        email={email}
                        first={first}
                        zip={zip}
                        last={last}
                        phone={phone}
                        country={country}
                        consent={consent}
                        drawing={drawing}
                        errors={errors}
                        setFull={setFull}
                        setEmail={setEmail}
                        setFirst={setFirst}
                        setLast={setLast}
                        setZip={setZip}
                        formatPhoneNumber={formatPhoneNumber}
                        onConsentChange={onConsentChange}
                        onDrawingChange={onDrawingChange}
                        setCountry={setCountry}
                        onNext={onNext}

                    />
                        <div className="modal-divider"></div>
                        <div className="modal-footer">
                        <FormButtons  
                            onSubmit={onSubmit}
                            onCheck={onCheck}
                        />
                    <div style={{paddingBottom: full ? 150 : 0}}></div>
                </div>
                </div>
        
            </div>}
            </>
        </Fade>
    )
}


const Form = props => {
    const {
        full,
        email,
        first,
        last,
        phone,
        zip,
        country,
        consent,
        errors,
        drawing,
        setFull,
        setEmail,
        setFirst,
        setLast,
        formatPhoneNumber,
        onConsentChange,
        setCountry,
        onDrawingChange,
        setZip,
        onNext
    } = props

    const onModalStateChange = (value) => {
        switch(value){
            case 2: setFull(true); break;
            default: setFull(false); break;
        }
    }

    const leaving = new Subject()

    useEffect(() => {
        ModalController.get()
        .pipe(takeUntil(leaving))
        .subscribe(onModalStateChange)
        return () => leaving.next()
    })
   


    return(
        <div className="form-container">
            <Input 
                hasError={errors.email}
                type={"email-address"}
                value={email}
                placeholder="Email"
                onChange={setEmail}
                onSubmit={onNext}
                required
            />

            <Collapse in={full} style={{width: '100%'}}>
                <Input 
                    hasError={errors.first}
                    value={first}
                    placeholder="First Name"
                    onChange={setFirst}
                    required
                />
            </Collapse>
            
            <Collapse in={full} style={{width: '100%'}}>
                <Input 
                    hasError={errors.last}
                    value={last}
                    placeholder="Last Name"
                    onChange={setLast}
                    required
                />
            </Collapse>
            
 
            <Collapse in={full} style={{width: '100%'}}>
                <Input 
                    hasError={errors.zip}
                    value={zip}
                    placeholder="Zip / Postal Code"
                    onChange={setZip}
                    required
                />
            </Collapse>
            <Collapse in={full} style={{width: '100%'}}>
                <CountrySelect value={country} onChange={(e) => setCountry(e?.target?.value)} required />
            </Collapse>


            {/* <Collapse in={full} style={{width: '100%', marginTop: 20}}>
                <div className="form-disclaimer" >
                    <Checkbox
                        className={`form-checkbox`}
                        checked={drawing}
                        onChange={onDrawingChange}
                        color="default"
                        labelStyle={{color: 'white'}}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                    <label className="form-check-input" onClick={onDrawingChange}>
                    I would like to register for a chance to win 1 of 5 free iPads*
                    </label>
                </div>
            </Collapse> */}

            <Collapse in={full} style={{width: '100%'}}>
                <Input 
                    hasError={errors.phone}
                    value={phone}
                    placeholder="Phone"
                    onChange={formatPhoneNumber}
                />
            </Collapse>
            <Collapse in={full} style={{width: '100%'}}>
            {/* <p> */}
                {/* *iPad drawing open to U.S. residents only */}
            {/* </p> */}
            </Collapse>
            <Collapse in={full} style={{width: '100%', marginTop: 20, backgroundColor: errors.consent ? "#FF000033" : "transparent", borderRadius: 5, padding: "5px 0px" }}>
                <div className="form-disclaimer" >
                    <Checkbox
                        className={`form-checkbox`}
                        required={true}
                        checked={consent}
                        style ={{
                            color: errors.consent ? "#FF0000" : "rgba(0, 0, 0, 0.54)",
                          }}
                        onChange={onConsentChange}
                        color="default"
                        labelStyle={{color: 'white'}}

                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                <label className="form-check-input" onClick={onConsentChange}>
           
                By submitting this form, I agree to receive reminders, updates about events and donation links from It Is Written to the email address and/or phone number provided above. <br/>
                Message frequency varies. Message and data rates may apply.

                Reply HELP to any message to receive help or STOP to cancel all further messages. View our <A href="https://www.itiswritten.com/terms-of-use/" target="_blank" >Terms of Service</A> and <A href="https://www.itiswritten.com/privacy-policy/" target="_blank">Privacy Policy</A>


                </label>

                </div>
            </Collapse>
            
        </div>
    )
}


// type FormButtonProps = {
//     onCheck: () => void
//     onSubmit: () => void
// }

const FormButtons = props => {
    const {onCheck, onSubmit} = props
    const [state, setState] = useState(0)
    const leaving = new Subject()
    useEffect(() => {
        ModalController.get()
        .pipe(takeUntil(leaving))
        .subscribe(setState)
        return () => leaving.next()
    })

    const _onSubmit = () => {
        if(onSubmit){
            onSubmit()
        }
    }

    const _onCheck = () => {
        if(onCheck){
            onCheck()
        }
    }


    const onNext = () => {
        switch(state){
            case 1: _onCheck(); break;
            case 2: _onSubmit(); break;
            default: noop();
        }
    }

    const onClose = () => {
        switch(state){
            case 1: ModalController.close(); break;
            case 2: ModalController.collapse(); break;
            default: noop();
        }
    }

    return(
        <div className="form-footer-container">
            <div className="form-footer">
                <button onClick={onClose} className="modal-btn form-footer-close-button">Close</button>
                <button  onClick={onNext}  className="modal-btn form-footer-next-button">Next</button>
            </div>
        </div>
    )
}


const CountrySelect = props => {
    const { required } = props

    
    const onChange = (value) => {
        props.onChange(value)
    }

    return(
        <div>
            <div className="form-select-group">
            <label className="input-title" htmlFor="country">Country{!required ? <span>&nbsp;( Optional )</span> : ""}</label>
            <select className="input" name="country" id="country" onChange={onChange}>
                <option defaultValue="selected" value="US">United States</option>
                <option disabled="disabled" value="---------------">---------------</option>
                {
                    map(COUNTRIES, country => {
                        return(
                            <option key={country.value} value={country.value}>{country.text}</option>
                        )
                    })
                }
            </select>
            </div>
        </div>
    )
}